<template>
  <div class="video-record-query">
    <el-card shadow="never" class="query-card">
      <div slot="header" class="card-header">
        <h3>
          <i class="el-icon-search"></i>
          已上传视频记录
        </h3>
        <div class="header-actions">
          <el-button-group style="margin-right: 10px">
            <el-button
                :type="viewMode === 'table' ? 'primary' : ''"
                icon="el-icon-s-grid"
                size="small"
                @click="viewMode = 'table'"
            >
              表格
            </el-button>
            <el-button
                :type="viewMode === 'card' ? 'primary' : ''"
                icon="el-icon-menu"
                size="small"
                @click="viewMode = 'card'"
            >
              卡片
            </el-button>
            <el-button
                :type="viewMode === 'thumbnail' ? 'primary' : ''"
                icon="el-icon-picture"
                size="small"
                @click="viewMode = 'thumbnail'"
            >
              缩略图
            </el-button>  <el-button
              :type="viewMode === 'list' ? 'primary' : ''"
              icon="el-icon-s-order"
              size="small"
              @click="viewMode = 'list'"
          >
            列表
          </el-button>
          </el-button-group>
          <el-button
              type="info"
              icon="el-icon-document"
              @click="openDeletedRecordsDialog"
              size="small"
          >
            删除记录
          </el-button>
          <el-button
              type="warning"
              icon="el-icon-view"
              @click="refreshCurrentPageMaterialReview"
              :loading="materialReviewLoading"
              :disabled="tableData.length === 0"
              size="small"
          >
            刷新审核
          </el-button>
          <el-button
              type="primary"
              icon="el-icon-refresh"
              @click="handleRefresh"
              :loading="loading"
              size="small"
          >
            刷新
          </el-button>
        </div>
      </div>

      <!-- 筛选区 -->
      <el-form :model="queryForm" inline class="query-form">
        <!-- 基础筛选条件 -->
        <el-form-item label="上传用户">
          <el-input
              v-model="queryForm.uploadPerson"
              placeholder="请输入上传用户（可选）"
              clearable              style="width: 200px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>

        <el-form-item label="文件目录">
          <el-select
              allow-create
              filterable
              v-model="queryForm.uploadType"
              placeholder="请选择游戏类型（可选）"
              clearable              style="width: 200px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
                v-for="folder in folderList"
                :key="folder.value"
                :label="folder.label"
                :value="folder.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="文件名">
          <el-input
              v-model="queryForm.fileName"
              placeholder="请输入文件名（可选）"
              clearable              style="width: 200px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>

        <el-form-item label="开始日期">
          <el-date-picker
              v-model="queryForm.startDate"
              type="date"
              placeholder="选择开始日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"              style="width: 160px"
          />
        </el-form-item>

        <el-form-item label="结束日期">
          <el-date-picker
              v-model="queryForm.endDate"
              type="date"
              placeholder="选择结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"              style="width: 160px"
          />
        </el-form-item>

        <!-- 动态添加的高级筛选条件 -->
        <template v-for="(filter, index) in advancedFilters">
          <!-- 消耗范围 -->
          <el-form-item
              v-if="filter.type === 'cost'"
              :key="'cost-' + index"
              label="消耗范围"
              class="advanced-filter-item"
          >
            <el-input-number
                v-model="filter.minValue"
                placeholder="最小"
                :min="0"
                :precision="2"
                controls-position="right"                style="width: 110px"
            />
            <span style="margin: 0 4px">-</span>
            <el-input-number
                v-model="filter.maxValue"
                placeholder="最大"
                :min="0"
                :precision="2"
                controls-position="right"                style="width: 110px"
            />
            <el-button
                type="text"
                icon="el-icon-close"
                @click="removeAdvancedFilter(index)"                style="margin-left: 4px; color: #f56c6c"
            ></el-button>
          </el-form-item>

          <!-- ROAS范围 -->
          <el-form-item
              v-if="filter.type === 'roas'"
              :key="'roas-' + index"
              label="ROAS范围"
              class="advanced-filter-item"
          >
            <el-input-number
                v-model="filter.minValue"
                placeholder="最小"
                :min="0"
                :precision="2"
                controls-position="right"                style="width: 110px"
            />
            <span style="margin: 0 4px">-</span>
            <el-input-number
                v-model="filter.maxValue"
                placeholder="最大"
                :min="0"
                :precision="2"
                controls-position="right"                style="width: 110px"
            />
            <el-button
                type="text"
                icon="el-icon-close"
                @click="removeAdvancedFilter(index)"                style="margin-left: 4px; color: #f56c6c"
            ></el-button>
          </el-form-item>

          <!-- 最小展示 -->
          <el-form-item
              v-if="filter.type === 'impressions'"
              :key="'impressions-' + index"
              label="最小展示"
              class="advanced-filter-item"
          >
            <el-input-number
                v-model="filter.value"
                placeholder="最小展示数"
                :min="0"
                controls-position="right"                style="width: 150px"
            />
            <el-button
                type="text"
                icon="el-icon-close"
                @click="removeAdvancedFilter(index)"                style="margin-left: 4px; color: #f56c6c"
            ></el-button>
          </el-form-item>

          <!-- 关键词 -->
          <el-form-item
              v-if="filter.type === 'keyword'"
              :key="'keyword-' + index"
              label="关键词"
              class="advanced-filter-item"
          >
            <el-input
                v-model="filter.value"
                placeholder="搜索关键词"
                clearable                style="width: 200px"
                @keyup.enter.native="handleQuery"
            />
            <el-button
                type="text"
                icon="el-icon-close"
                @click="removeAdvancedFilter(index)"                style="margin-left: 4px; color: #f56c6c"
            ></el-button>
          </el-form-item>

          <!-- 排序方式 -->
          <el-form-item
              v-if="filter.type === 'sortBy'"
              :key="'sortBy-' + index"
              label="排序方式"
              class="advanced-filter-item"
          >
            <el-select
                v-model="filter.value"
                placeholder="请选择"                style="width: 140px"
            >
              <el-option label="消耗" value="lifetimeCost"></el-option>
              <el-option label="ROAS" value="lifetimeRoas"></el-option>
              <el-option label="展示数" value="lifetimeImpressions"></el-option>
              <el-option label="点击数" value="lifetimeClicks"></el-option>
              <el-option label="转化数" value="lifetimeConversions"></el-option>
            </el-select>
            <el-button
                type="text"
                icon="el-icon-close"
                @click="removeAdvancedFilter(index)"                style="margin-left: 4px; color: #f56c6c"
            ></el-button>
          </el-form-item>

          <!-- 排序顺序 -->
          <el-form-item
              v-if="filter.type === 'order'"
              :key="'order-' + index"
              label="排序"
              class="advanced-filter-item"
          >
            <el-select
                v-model="filter.value"
                placeholder="请选择"                style="width: 100px"
            >
              <el-option label="降序" value="desc"></el-option>
              <el-option label="升序" value="asc"></el-option>
            </el-select>
            <el-button
                type="text"
                icon="el-icon-close"
                @click="removeAdvancedFilter(index)"                style="margin-left: 4px; color: #f56c6c"
            ></el-button>
          </el-form-item>
        </template>

        <!-- 添加筛选条件按钮 -->
        <el-form-item>
          <el-dropdown @command="handleAddFilter" trigger="click">
            <el-button type="primary" plain icon="el-icon-plus" size="small">
              添加筛选
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="cost" :disabled="hasFilter('cost')">
                <i class="el-icon-money"></i> 消耗范围
              </el-dropdown-item>
              <el-dropdown-item command="roas" :disabled="hasFilter('roas')">
                <i class="el-icon-data-line"></i> ROAS范围
              </el-dropdown-item>
              <el-dropdown-item command="impressions" :disabled="hasFilter('impressions')">
                <i class="el-icon-view"></i> 最小展示
              </el-dropdown-item>
              <el-dropdown-item command="keyword" :disabled="hasFilter('keyword')">
                <i class="el-icon-search"></i> 关键词
              </el-dropdown-item>
              <el-dropdown-item command="sortBy" :disabled="hasFilter('sortBy')">
                <i class="el-icon-sort"></i> 排序方式
              </el-dropdown-item>
              <el-dropdown-item command="order" :disabled="hasFilter('order')">
                <i class="el-icon-sort-down"></i> 排序顺序
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleQuery" :loading="loading">
            查询
          </el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- 统计信息 -->
      <div class="stats-bar" v-if="pagination.totalElements > 0">
        <el-tag type="info" size="medium">
          总计: {{ pagination.totalElements }} 个视频
        </el-tag>
        <el-tag type="success" size="medium" style="margin-left: 8px">
          当前页: {{ pagination.page }} / {{ pagination.totalPages }}
        </el-tag>
        <el-tag
            v-if="selectedVideos.length > 0"
            type="primary"
            size="medium"
            style="margin-left: 8px"
        >
          已选中: {{ selectedVideos.length }} 个
        </el-tag>
        <el-tag type="success" size="medium" style="margin-left: 8px">
          通过: {{ reviewStats.passed }}
        </el-tag>
        <el-tag type="danger" size="medium" style="margin-left: 8px">
          失败: {{ reviewStats.rejected }}
        </el-tag>
        <el-tag type="warning" size="medium" style="margin-left: 8px">
          审核中: {{ reviewStats.pending }}
        </el-tag>
        <el-tag type="info" size="medium" style="margin-left: 8px">
          未投放: {{ reviewStats.noAdMaterial }}
        </el-tag>
      </div>

      <!-- 批量操作区 -->
      <div class="batch-actions" v-if="selectedVideos.length > 0">
        <el-alert
            :title="`已选择 ${selectedVideos.length} 个视频`"
            type="success"
            :closable="false"
            show-icon
        />
        <div class="action-buttons">
          <el-button
              type="primary"
              size="small"
              icon="el-icon-check"
              @click="handleSelectAllOnPage"
          >
            全选当前页
          </el-button>
          <el-button
              type="warning"
              size="small"
              icon="el-icon-close"
              @click="handleClearSelection"
          >
            取消选择
          </el-button>
          <el-button
              type="success"
              size="small"
              icon="el-icon-share"
              @click="handleAssignToAds"
          >
            添加到创建区
          </el-button>
          <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              :loading="deleteLoading"
              @click="handleBatchDelete"
          >
            批量删除
          </el-button>
        </div>
      </div>

      <!-- 表格区 -->
      <el-table
          v-if="viewMode === 'table'"
          :data="tableData"
          v-loading="loading"
          border
          stripe
          max-height="600"
          style="margin-top: 16px"
          @selection-change="handleSelectionChange"
      >
        <el-table-column
            type="selection"
            width="55"
            :selectable="checkSelectable"
        />
        <el-table-column
            prop="fileName"
            label="文件名"
            min-width="180"
            show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span>{{ row.fileName || row.originalFileName }}</span>
          </template>
        </el-table-column>

        <el-table-column
            prop="videoId"
            label="视频ID"
            width="330"
        >
          <template slot-scope="{ row }">
            <div class="id-cell" v-if="row.videoId">
              <span>{{ row.videoId }}</span>
              <i
                  class="el-icon-document-copy copy-icon"
                  @click="copyToClipboard(row.videoId)"
              ></i>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            prop="materialId"
            label="素材ID"
            width="300"
        >
          <template slot-scope="{ row }">
            <div class="id-cell" v-if="row.materialId">
              <span>{{ row.materialId }}</span>
              <i
                  class="el-icon-document-copy copy-icon"
                  @click="copyToClipboard(row.materialId)"
              ></i>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="审核统计"
            width="130"
        >
          <template slot-scope="{ row }">
            <el-tag :type="getReviewTagType(row)" size="mini">
              {{ getReviewSummaryText(row) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
            label="累计消耗"
            width="120"
            sortable
        >
          <template slot-scope="{ row }">
            <span v-if="row.lifetimeCost !== null && row.lifetimeCost !== undefined" style="color: #f56c6c; font-weight: 500">
              ¥{{ row.lifetimeCost.toFixed(2) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="ROAS"
            width="100"
            sortable
        >
          <template slot-scope="{ row }">
            <el-tag
                v-if="row.lifetimeRoas !== null && row.lifetimeRoas !== undefined"
                :type="row.lifetimeRoas >= 1 ? 'success' : 'warning'"
                size="small"
            >
              {{ row.lifetimeRoas.toFixed(4) }}
            </el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="展示数"
            width="110"
            sortable
        >
          <template slot-scope="{ row }">
            <span v-if="row.lifetimeImpressions">{{ row.lifetimeImpressions.toLocaleString() }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="点击数"
            width="100"
            sortable
        >
          <template slot-scope="{ row }">
            <span v-if="row.lifetimeClicks">{{ row.lifetimeClicks.toLocaleString() }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="转化数"
            width="100"
            sortable
        >
          <template slot-scope="{ row }">
            <span v-if="row.lifetimeConversions">{{ row.lifetimeConversions.toLocaleString() }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="CTR"
            width="90"
        >
          <template slot-scope="{ row }">
            <span v-if="row.lifetimeCtr !== null && row.lifetimeCtr !== undefined">
              {{ (row.lifetimeCtr * 100).toFixed(2) }}%
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="CPC"
            width="90"
        >
          <template slot-scope="{ row }">
            <span v-if="row.lifetimeCpc !== null && row.lifetimeCpc !== undefined">
              ¥{{ row.lifetimeCpc.toFixed(2) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="CPM"
            width="90"
        >
          <template slot-scope="{ row }">
            <span v-if="row.lifetimeCpm !== null && row.lifetimeCpm !== undefined">
              ¥{{ row.lifetimeCpm.toFixed(2) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="转化率"
            width="100"
        >
          <template slot-scope="{ row }">
            <span v-if="row.lifetimeConversionRate !== null && row.lifetimeConversionRate !== undefined">
              {{ row.lifetimeConversionRate.toFixed(2) }}%
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="活跃天数"
            width="90"
        >
          <template slot-scope="{ row }">
            <el-tag v-if="row.activeDays" type="info" size="small">
              {{ row.activeDays }}天
            </el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="首次使用"
            width="110"
        >
          <template slot-scope="{ row }">
            <span v-if="row.firstUsedDate">{{ row.firstUsedDate }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="最近活跃"
            width="110"
        >
          <template slot-scope="{ row }">
            <span v-if="row.lastActiveDate">{{ row.lastActiveDate }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="视频信息"
            width="150"
        >
          <template slot-scope="{ row }">
            <div v-if="row.duration">
              <div>时长: {{ formatDuration(row.duration) }}</div>
              <div v-if="row.width && row.height">
                分辨率: {{ row.width }}x{{ row.height }}
              </div>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
            label="文件大小"
            width="120"
        >
          <template slot-scope="{ row }">
            {{ formatFileSize(row.fileSize) }}
          </template>
        </el-table-column>

        <el-table-column
            prop="uploadStatus"
            label="状态"
            width="100"
        >
          <template slot-scope="{ row }">
            <el-tag :type="getStatusType(row.uploadStatus)" size="small">
              {{ getStatusText(row.uploadStatus) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
            prop="recordCreatedAt"
            label="上传时间"
            width="180"
        >
          <template slot-scope="{ row }">
            {{ formatTime(row.recordCreatedAt) }}
          </template>
        </el-table-column>

        <el-table-column
            label="操作"
            width="190"
        >
          <template slot-scope="{ row }">
            <el-button
                v-if="row.previewUrl"
                type="text"
                size="small"
                @click="handlePreview(row)"
            >
              预览
            </el-button>
            <el-button
                type="text"
                size="small"
                @click="handleCopyInfo(row)"
            >
              复制信息
            </el-button>
            <el-button
                type="text"
                size="small"
                class="danger-text-btn"
                :loading="deleteLoading"
                @click="handleDeleteVideo(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 卡片视图 -->
      <div
        v-if="viewMode === 'card'"
        v-loading="loading"
        class="card-view"
        ref="cardViewContainer"
        @mousedown="handleMouseDown"
      >
        <div class="video-cards">
          <div
              v-for="(row, index) in tableData"
              :key="index"
              class="video-card"
              :class="{ 'selected': isVideoSelected(row), 'selecting': isSelectingCard(row) }"
              :data-index="index"
          >
            <!-- 选择框 -->
            <el-checkbox
                v-model="row._selected"
                class="video-checkbox"
                @change="handleCardSelectionChange(row)"
                @click.stop
                :disabled="!row.imageId"
            ></el-checkbox>

            <!-- 缺少封面ID提示 -->
            <div class="missing-badge" v-if="!row.imageId">
              <el-tag size="mini" type="warning" effect="dark">
                <i class="el-icon-warning"></i> 缺少封面ID等待1分钟自动修复
              </el-tag>
            </div>

            <!-- 视频预览 - 使用img替代video提升性能，hover时播放 -->
            <div class="card-preview" 
                 v-if="row.previewUrl"
                 @mouseenter="handleCardHover($event, row, true)"
                 @mouseleave="handleCardHover($event, row, false)">
              <!-- 默认显示图片 -->
              <img
                  v-if="!isCardPlaying(index)"
                  :src="getVideoThumbnail(row)"
                  alt="视频封面"
                  class="card-image"
                  @error="handleImageError($event, row)"
                  loading="lazy"
              />
              <!-- hover时显示video并播放 -->
              <video
                  v-if="isCardPlaying(index)"
                  :src="row.previewUrl"
                  autoplay
                  muted
                  loop
                  controls
                  class="card-video"
                  @click.stop
              ></video>
            </div>
            <div class="card-preview no-preview" v-else>
              <i class="el-icon-video-camera"></i>
              <span>无预览</span>
            </div>

            <!-- 卡片内容 -->
            <div class="card-content">
              <div class="card-title" :title="row.fileName || row.originalFileName">
                {{ row.fileName || row.originalFileName }}
              </div>
              <div class="review-summary-line">
                <el-tag :type="getReviewTagType(row)" size="mini">
                  {{ getReviewSummaryText(row) }}
                </el-tag>
              </div>

              <div class="card-info">

                <!-- 印章样式的上新标识 -->
                <div class="stamp-badge" v-if="isNewVideo(row)">
                  <span class="stamp-text">上新</span>
                </div>

                <!-- 性能数据区域 -->
                <div class="performance-section" v-if="row.lifetimeCost !== null && row.lifetimeCost !== undefined">
                  <div class="info-item performance-highlight">
                    <span class="label">累计消耗:</span>
                    <span class="value cost-value">¥{{ row.lifetimeCost.toFixed(2) }}</span>
                  </div>

                  <div class="performance-grid">
                    <div class="info-item" v-if="row.lifetimeRoas !== null && row.lifetimeRoas !== undefined">
                      <el-tag
                          :type="row.lifetimeRoas >= 1 ? 'success' : 'warning'"
                          size="mini"
                          effect="dark"
                      >
                        ROAS: {{ row.lifetimeRoas.toFixed(4) }}
                      </el-tag>
                    </div>

                    <div class="info-item" v-if="row.lifetimeImpressions">
                      <span class="label">展示:</span>
                      <span class="value">{{ row.lifetimeImpressions.toLocaleString() }}</span>
                    </div>

                    <div class="info-item" v-if="row.lifetimeClicks">
                      <span class="label">点击:</span>
                      <span class="value">{{ row.lifetimeClicks.toLocaleString() }}</span>
                    </div>

                    <div class="info-item" v-if="row.lifetimeConversions">
                      <span class="label">转化:</span>
                      <span class="value">{{ row.lifetimeConversions.toLocaleString() }}</span>
                    </div>

                    <div class="info-item" v-if="row.lifetimeCtr !== null && row.lifetimeCtr !== undefined">
                      <span class="label">CTR:</span>
                      <span class="value">{{ (row.lifetimeCtr * 100).toFixed(2) }}%</span>
                    </div>

                    <div class="info-item" v-if="row.lifetimeCpc !== null && row.lifetimeCpc !== undefined">
                      <span class="label">CPC:</span>
                      <span class="value">¥{{ row.lifetimeCpc.toFixed(2) }}</span>
                    </div>

                    <div class="info-item" v-if="row.lifetimeConversionRate !== null && row.lifetimeConversionRate !== undefined">
                      <span class="label">转化率:</span>
                      <span class="value">{{ row.lifetimeConversionRate.toFixed(2) }}%</span>
                    </div>

                    <div class="info-item" v-if="row.activeDays">
                      <el-tag size="mini" type="info" effect="plain">
                        活跃: {{ row.activeDays }}天
                      </el-tag>
                    </div>
                  </div>

                  <div class="performance-dates" v-if="row.firstUsedDate || row.lastActiveDate">
                    <span v-if="row.firstUsedDate" class="date-text">首次: {{ row.firstUsedDate }}</span>
                    <span v-if="row.lastActiveDate" class="date-text">最近: {{ row.lastActiveDate }}</span>
                  </div>

                  <!-- 查看趋势按钮 -->
                  <div class="performance-actions">
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-data-line"
                        @click.stop="handleViewTrend(row)"
                    >
                      查看15天趋势
                    </el-button>
                  </div>
                </div>

<!--                <div class="info-item" v-if="row.videoId">-->
<!--                  <span class="label">视频ID:</span>-->
<!--                  <span class="value">{{ row.videoId }}</span>-->
<!--                  <i-->
<!--                      class="el-icon-document-copy copy-icon-small"-->
<!--                      @click="copyToClipboard(row.videoId)"-->
<!--                  ></i>-->
<!--                </div>-->
<!--                <div class="info-item" v-if="row.uploadPerson">-->
<!--                  <span class="label">上传用户:</span>-->
<!--                  <el-tag size="mini" type="success" effect="plain">-->
<!--                    {{ row.uploadPerson }}-->
<!--                  </el-tag>-->
<!--                </div>-->

<!--                <div class="info-item" v-if="row.uploadVideoType">-->
<!--                  <span class="label">上传类型:</span>-->
<!--                  <el-tag-->
<!--                      size="mini"-->
<!--                      effect="light"-->
<!--                  >-->
<!--                    {{ row.uploadVideoType }}-->
<!--                  </el-tag>-->
<!--                </div>-->
<!--                <div class="info-item" v-if="row.materialId">-->
<!--                  <span class="label">素材ID:</span>-->
<!--                  <span class="value">{{ row.materialId }}</span>-->
<!--                  <i-->
<!--                      class="el-icon-document-copy copy-icon-small"-->
<!--                      @click="copyToClipboard(row.materialId)"-->
<!--                  ></i>-->
<!--                </div>-->
<!--                <div class="info-item" v-if="row.imageId">-->
<!--                  <span class="label">封面ID:</span>-->
<!--                  <span class="value">{{ row.imageId }}</span>-->
<!--                  <i-->
<!--                      class="el-icon-document-copy copy-icon-small"-->
<!--                      @click="copyToClipboard(row.imageId)"-->
<!--                  ></i>-->
<!--                </div>-->
                <div class="info-item" v-if="row.duration">
                  <span class="label">时长:</span>
                  <span class="value">{{ formatDuration(row.duration) }}</span>
                </div>

                <div class="info-item" v-if="row.width && row.height">
                  <span class="label">分辨率:</span>
                  <span class="value">{{ row.width }}x{{ row.height }}</span>
                </div>

                <div class="info-item" v-if="row.fileSize">
                  <span class="label">大小:</span>
                  <span class="value">{{ formatFileSize(row.fileSize) }}</span>
                </div>

                <div class="info-item" v-if="row.recordCreatedAt">
                  <span class="label">上传时间:</span>
                  <span class="value">{{ formatTime(row.recordCreatedAt) }}</span>
                </div>
              </div>
              <div class="card-actions">
                <el-button
                    size="mini"
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    :loading="deleteLoading"
                    @click.stop="handleDeleteVideo(row)"
                >
                  删除
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 选择框 -->
        <div
          v-if="isDragging"
          class="selection-box"
          :style="selectionBoxStyle"
        ></div>
      </div>

      <!-- 缩略图视图 -->
      <div
          v-else-if="viewMode === 'thumbnail'"
          v-loading="loading"
          class="thumbnail-view"
          ref="thumbnailViewContainer"
          @mousedown="handleThumbnailMouseDown"
      >
        <div class="thumbnail-grid">
          <div
              v-for="(row, index) in tableData"
              :key="index"
              class="thumbnail-item"
              :class="{
                'selected': isVideoSelected(row),
                'disabled': !row.imageId,
                'selecting': isSelectingThumbnail(row)
              }"
              :data-index="index"
          >
            <!-- 选择框 -->
            <div class="thumbnail-checkbox">
              <el-checkbox
                  v-model="row._selected"
                  :disabled="!row.imageId"
                  @click.native.stop
                  @change="handleCardSelectionChange(row)"
              ></el-checkbox>
            </div>

            <!-- 缺少封面ID提示 -->
            <div class="thumbnail-missing-badge" v-if="!row.imageId">
              <i class="el-icon-warning"></i>
            </div>

            <!-- 缩略图上新标识 - New + 火苗特效 -->
            <div class="thumbnail-new-badge" v-if="isNewVideo(row)">
              <span class="new-text">New</span>
              <i class="el-icon-hot-water fire-icon"></i>
            </div>

            <!-- 视频预览 - 使用img替代video提升性能，hover时播放 -->
            <div class="thumbnail-preview" 
                 @mouseenter="handleThumbnailHover($event, row, true)"
                 @mouseleave="handleThumbnailHover($event, row, false)">
              <!-- 默认显示图片 -->
              <img
                  v-if="row.previewUrl && !isThumbnailPlaying(index)"
                  :src="getVideoThumbnail(row)"
                  alt="视频封面"
                  class="thumbnail-image"
                  @error="handleImageError($event, row)"
                  loading="lazy"
              />
              <!-- hover时显示video并播放 -->
              <video
                  v-if="row.previewUrl && isThumbnailPlaying(index)"
                  :src="row.previewUrl"
                  autoplay
                  muted
                  loop
                  class="thumbnail-video"
              ></video>
            </div>

            <!-- 简要信息 -->
            <div class="thumbnail-info">
              <el-tooltip :content="row.fileName || row.originalFileName" placement="top">
                <div class="thumbnail-name">{{ truncate(row.fileName || row.originalFileName, 18) }}</div>
              </el-tooltip>
              <!-- 性能数据 -->
              <div class="thumbnail-performance" v-if="row.lifetimeCost !== null && row.lifetimeCost !== undefined">
                <div class="perf-item cost-item">
                  <i class="el-icon-money"></i>
                  <span>¥{{ row.lifetimeCost.toFixed(0) }}</span>
                </div>
                <div class="perf-item roas-item" v-if="row.lifetimeRoas !== null && row.lifetimeRoas !== undefined">
                  <i class="el-icon-data-line"></i>
                  <span>{{ row.lifetimeRoas.toFixed(2) }}</span>
                </div>
              </div>
              <div class="thumbnail-meta">
                <el-tag
                  v-if="row.uploadPerson"
                  size="mini"
                  type="success"
                  effect="plain"
                  class="meta-tag"
                >
                  {{ row.uploadPerson }}
                </el-tag>
                <span v-if="row.duration" class="duration-text">
                  {{ formatDuration(row.duration) }}
                </span>
              </div>
              <div class="review-summary-line">
                <el-tag :type="getReviewTagType(row)" size="mini">
                  {{ getReviewSummaryText(row) }}
                </el-tag>
              </div>
            </div>
            <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                size="mini"
                :loading="deleteLoading"
                class="thumbnail-delete-btn"
                @click.stop="handleDeleteVideo(row)"
            ></el-button>
          </div>
        </div>

        <!-- 空状态 -->
        <el-empty
            v-if="!loading && tableData.length === 0"
            description="暂无视频记录"
            :image-size="120"
        />
        <!-- 选择框 -->
        <div
            v-if="isDraggingThumbnail"
            class="thumbnail-selection-box"
            :style="thumbnailSelectionBoxStyle"
        ></div>
      </div>
      <!-- 列表视图（文件管理器风格） -->
      <div
          v-else-if="viewMode === 'list'"
          v-loading="loading"
          class="list-view"
          ref="listViewContainer"
          @mousedown="handleListMouseDown"
      >
        <div class="file-list">
          <div
              v-for="(row, index) in tableData"
              :key="index"
              class="file-item"
              :class="{
                'selected': isVideoSelected(row),
                'disabled': !row.imageId,
                'selecting': isSelectingListItem(row)
              }"
              :data-index="index"
          >
            <!-- 文件图标 -->
            <div class="file-icon">
              <i class="el-icon-video-camera"></i>
            </div>
            <!-- 文件信息 -->
            <div class="file-info">
              <div class="file-name" :title="row.fileName || row.originalFileName">
                {{ row.fileName || row.originalFileName }}
              </div>
              <div class="file-meta">
                <span class="meta-item" v-if="row.fileSize">
                  {{ formatFileSize(row.fileSize) }}
                </span>
                <span class="meta-separator" v-if="row.fileSize && row.recordCreatedAt">|</span>
                <span class="meta-item" v-if="row.recordCreatedAt">
                  {{ formatTime(row.recordCreatedAt) }}
                </span>
                <span class="meta-separator" v-if="row.fileSize || row.recordCreatedAt">|</span>
                <el-tag :type="getReviewTagType(row)" size="mini">
                  {{ getReviewSummaryText(row) }}
                </el-tag>
              </div>
            </div>

            <!-- 选择框 -->
<!--            <el-checkbox-->
<!--                v-model="row._selected"-->
<!--                :disabled="!row.imageId"-->
<!--                @click.native.stop-->
<!--                @change="handleCardSelectionChange(row)"-->
<!--                class="file-checkbox"-->
<!--            ></el-checkbox>-->

            <!-- 预览按钮 -->
            <el-button
                v-if="row.previewUrl"
                type="text"
                icon="el-icon-video-play"
                @click.stop="handlePreview(row)"
                class="file-preview-btn"
            ></el-button>
            <el-button
                type="text"
                icon="el-icon-delete"
                :loading="deleteLoading"
                @click.stop="handleDeleteVideo(row)"
                class="file-delete-btn"
            ></el-button>
          </div>
        </div>

        <!-- 空状态 -->
        <el-empty
            v-if="!loading && tableData.length === 0"
            description="暂无视频记录"
            :image-size="120"
        />

        <!-- 选择框 -->
        <div
            v-if="isDraggingList"
            class="list-selection-box"
            :style="listSelectionBoxStyle"
        ></div>
      </div>
      <!-- 分页区 -->
      <div class="pagination-container" v-if="pagination.totalElements > 0">
        <el-pagination
            background
            :current-page="pagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.pageSize"
            :total="pagination.totalElements"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
        />
      </div>

      <!-- 空状态 -->
      <el-empty
          v-if="!loading && tableData.length === 0"
          description="暂无视频记录"
          :image-size="120"
      >
        <el-button type="primary" @click="handleQuery">
          点击查询
        </el-button>
      </el-empty>
    </el-card>

    <el-dialog
        title="删除记录"
        :visible.sync="deleteRecordDialogVisible"
        width="900px"
        append-to-body
    >
      <div class="delete-record-toolbar">
        <el-input
            v-model="deletedRecordQuery.uploadPerson"
            placeholder="上传用户"
            clearable
            size="small"
            style="width: 160px"
            @keyup.enter.native="loadDeletedRecords"
        />
        <el-input
            v-model="deletedRecordQuery.fileName"
            placeholder="文件名"
            clearable
            size="small"
            style="width: 220px"
            @keyup.enter.native="loadDeletedRecords"
        />
        <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            :loading="deletedRecordLoading"
            @click="loadDeletedRecords"
        >
          查询
        </el-button>
        <el-button
            size="small"
            icon="el-icon-refresh-left"
            @click="resetDeletedRecordQuery"
        >
          重置
        </el-button>
      </div>

      <el-table
          :data="deletedRecords"
          v-loading="deletedRecordLoading"
          border
          stripe
          max-height="520"
      >
        <el-table-column prop="fileName" label="文件名" min-width="180" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.fileName || row.originalFileName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="videoId" label="视频 ID" min-width="180" show-overflow-tooltip />
        <el-table-column prop="materialId" label="素材 ID" min-width="180" show-overflow-tooltip />
        <el-table-column prop="deletedBy" label="删除人" width="120" />
        <el-table-column prop="deletedAt" label="删除时间" width="180">
          <template slot-scope="{ row }">
            {{ formatTime(row.deletedAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="deleteReason" label="删除原因" min-width="180" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.deleteReason || '-' }}
          </template>
        </el-table-column>
      </el-table>

      <div class="delete-record-pagination" v-if="deletedRecordPagination.totalElements > 0">
        <el-pagination
            background
            :current-page="deletedRecordPagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="deletedRecordPagination.pageSize"
            :total="deletedRecordPagination.totalElements"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleDeletedRecordSizeChange"
            @current-change="handleDeletedRecordPageChange"
        />
      </div>
    </el-dialog>

    <!-- 预览对话框 -->
    <el-dialog
        title="视频预览"
        :visible.sync="previewVisible"
        width="600px"
        append-to-body
    >
      <video
          v-if="previewUrl"
          :src="previewUrl"
          controls
          style="width: 100%"
      ></video>


    </el-dialog>

    <!-- 分配到广告对话框 -->
    <el-dialog
        title="确认选择视频"
        :visible.sync="assignDialogVisible"
        width="600px"
        append-to-body
    >
      <el-alert
          :title="`已选择 ${selectedVideos.length} 个视频`"
          type="success"
          :closable="false"
          show-icon
          style="margin-bottom: 16px"
      />

      <div class="selected-videos-list">
        <el-tag
            v-for="(video, index) in selectedVideos"
            :key="index"
            size="small"
            style="margin-right: 8px; margin-bottom: 8px"
        >
          {{ video.fileName || video.originalFileName }}
        </el-tag>
      </div>

      <div class="dialog-tip" style="margin-top: 16px; color: #909399; font-size: 13px">
        <i class="el-icon-info"></i>
        点击确认后，视频将传递到父组件进行分配
      </div>

      <span slot="footer">
        <el-button @click="assignDialogVisible = false">取消</el-button>
        <el-button
            type="primary"
            @click="confirmAssign"
            :disabled="selectedVideos.length === 0"
        >
          确认选择 ({{ selectedVideos.length }} 个视频)
        </el-button>
      </span>
    </el-dialog>


    <!-- 15天趋势对话框 -->
    <el-dialog
        title="素材15天性能趋势"
        :visible.sync="trendDialogVisible"
        width="900px"
        append-to-body
        :close-on-click-modal="false"
    >
      <div v-loading="trendLoading" class="trend-dialog-content">
        <div v-if="!trendLoading && trendData" class="trend-content">
          <!-- 文件信息 -->
          <div class="trend-header">
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="文件名">
                {{ trendData.file_name }}
              </el-descriptions-item>
              <el-descriptions-item label="数据天数">
                {{ trendData.count }} 天
              </el-descriptions-item>
            </el-descriptions>
          </div>

          <!-- 汇总数据 -->
          <div class="trend-summary" v-if="trendData.summary">
            <h4 class="summary-title">
              <i class="el-icon-data-analysis"></i> 15天汇总
            </h4>
            <div class="summary-cards">
              <div class="summary-card cost-card">
                <div class="card-label">总消耗</div>
                <div class="card-value">¥{{ trendData.summary.total_cost ? trendData.summary.total_cost.toFixed(2) : '0.00' }}</div>
              </div>
              <div class="summary-card roas-card">
                <div class="card-label">平均ROAS</div>
                <div class="card-value">{{ trendData.summary.avg_roas ? trendData.summary.avg_roas.toFixed(4) : '0.0000' }}</div>
              </div>
              <div class="summary-card impressions-card">
                <div class="card-label">总展示</div>
                <div class="card-value">{{ trendData.summary.total_impressions ? trendData.summary.total_impressions.toLocaleString() : '0' }}</div>
              </div>
              <div class="summary-card clicks-card">
                <div class="card-label">总点击</div>
                <div class="card-value">{{ trendData.summary.total_clicks ? trendData.summary.total_clicks.toLocaleString() : '0' }}</div>
              </div>
              <div class="summary-card conversions-card">
                <div class="card-label">总转化</div>
                <div class="card-value">{{ trendData.summary.total_conversions ? trendData.summary.total_conversions.toLocaleString() : '0' }}</div>
              </div>
              <div class="summary-card ctr-card">
                <div class="card-label">平均CTR</div>
                <div class="card-value">{{ ((trendData.summary.avg_ctr || 0) * 100).toFixed(2) }}%</div>
              </div>
            </div>
          </div>

          <!-- 每日数据表格 -->
          <div class="trend-table-container">
            <h4 class="table-title">
              <i class="el-icon-date"></i> 每日详细数据
            </h4>
            <el-table
                :data="trendData.daily_stats"
                border
                stripe
                max-height="400"
                size="small"
            >
              <el-table-column prop="date" label="日期" width="120" fixed></el-table-column>
              <el-table-column label="消耗" width="120" sortable>
                <template slot-scope="{ row }">
                  <span style="color: #f56c6c; font-weight: 500">
                    ¥{{ row.cost ? row.cost.toFixed(2) : '0.00' }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="ROAS" width="100" sortable>
                <template slot-scope="{ row }">
                  <el-tag
                      :type="row.roas >= 1 ? 'success' : 'warning'"
                      size="mini"
                  >
                    {{ row.roas ? row.roas.toFixed(4) : '0.0000' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="展示数" width="110" sortable>
                <template slot-scope="{ row }">
                  {{ row.impressions ? row.impressions.toLocaleString() : '0' }}
                </template>
              </el-table-column>
              <el-table-column label="点击数" width="100" sortable>
                <template slot-scope="{ row }">
                  {{ row.clicks ? row.clicks.toLocaleString() : '0' }}
                </template>
              </el-table-column>
              <el-table-column label="转化数" width="100" sortable>
                <template slot-scope="{ row }">
                  {{ row.conversions ? row.conversions.toLocaleString() : '0' }}
                </template>
              </el-table-column>
              <el-table-column label="CTR" width="90">
                <template slot-scope="{ row }">
                  {{ ((row.ctr || 0) * 100).toFixed(2) }}%
                </template>
              </el-table-column>
              <el-table-column label="CPC" width="90">
                <template slot-scope="{ row }">
                  ¥{{ row.cpc ? row.cpc.toFixed(2) : '0.00' }}
                </template>
              </el-table-column>
              <el-table-column label="CPM" width="90">
                <template slot-scope="{ row }">
                  ¥{{ row.cpm ? row.cpm.toFixed(2) : '0.00' }}
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 空状态 -->
          <el-empty
              v-if="!trendLoading && (!trendData || !trendData.daily_stats || trendData.daily_stats.length === 0)"
              description="暂无趋势数据"
              :image-size="100"
          />
        </div>

        <span slot="footer">
        <el-button @click="trendDialogVisible = false">关闭</el-button>
      </span>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'VideoRecordQuery',

  props: {
    baseUrl: {
      type: String,
      // default: 'https://tiktoktf.darknight.games/api/api'
      default: 'https://tiktoktf.darknight.games//api/api'
    },

    advertiserId: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      // 15天趋势相关
      trendDialogVisible: false,
      trendLoading: false,
      trendData: null,
      // 高级筛选条件列表
      advancedFilters: [],
      folderList: [],
      queryForm: {
        advertiserId: '',
        uploadPerson: this.$store.state.username || this.$store.state.user?.username || '',
        uploadType: '',
        fileName: '',
        startDate: '',
        endDate: '',
        minCost: null,
        maxCost: null,
        minRoas: null,
        maxRoas: null,
        minImpressions: null,
        keyword: '',
        sortBy: 'lifetimeCost',
        order: 'desc'
      },

      tableData: [],
      loading: false,

      pagination: {
        page: 1,
        pageSize: 20,
        totalElements: 0,
        totalPages: 0,
        hasNext: false,
        hasPrevious: false
      },

      previewVisible: false,
      previewUrl: '',

      viewMode: 'card',

      selectedVideos: [],

      selectedVideoIds: new Set(),

      deleteLoading: false,
      materialReviewLoading: false,
      deleteRecordDialogVisible: false,
      deletedRecords: [],
      deletedRecordLoading: false,
      deletedRecordQuery: {
        uploadPerson: '',
        fileName: ''
      },
      deletedRecordPagination: {
        page: 1,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0
      },

      assignDialogVisible: false,

      hasLoadedOnce: false,

      // 拉框选择相关
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      dragCurrentX: 0,
      dragCurrentY: 0,
      selectionBoxStyle: {
        left: '0px',
        top: '0px',
        width: '0px',
        height: '0px'
      },
      // 缩略图拖拽选择相关
      isDraggingThumbnail: false,
      thumbnailDragStartX: 0,
      thumbnailDragStartY: 0,
      thumbnailDragCurrentX: 0,
      thumbnailDragCurrentY: 0,
      thumbnailSelectionBoxStyle: {
        left: '0px',
        top: '0px',
        width: '0px',
        height: '0px'
      },
      thumbnailClickTarget: null,
      // 列表视图拖拽选择相关
      isDraggingList: false,
      listDragStartX: 0,
      listDragStartY: 0,
      listDragCurrentX: 0,
      listDragCurrentY: 0,
      listSelectionBoxStyle: {
        left: '0px',
        top: '0px',
        width: '0px',
        height: '0px'
      },
      listClickTarget: null,
      
      // localStorage 键名
      STORAGE_KEY: 'video_record_query_form',
      
      // 缩略图hover播放状态管理
      playingThumbnailIndex: null,
      
      // 卡片视图hover播放状态管理
      playingCardIndex: null
    }
  },
  created() {
    if (this.advertiserId) {
      this.queryForm.advertiserId = this.advertiserId
    }
    // 从 localStorage 恢复查询条件
    this.loadQueryFormFromStorage()
    this.loadFolderList()
    this.handleQuery()
    this.hasLoadedOnce = true

    window.addEventListener('mouseup', this.handleMouseUp)
    window.addEventListener('mousemove', this.handleMouseMove)
  },

  beforeDestroy() {
    window.removeEventListener('mouseup', this.handleMouseUp)
    window.removeEventListener('mousemove', this.handleMouseMove)
    window.removeEventListener('mouseup', this.handleThumbnailMouseUp)
    window.removeEventListener('mousemove', this.handleThumbnailMouseMove)
    window.removeEventListener('mouseup', this.handleListMouseUp)
    window.removeEventListener('mousemove', this.handleListMouseMove)
  },

  watch: {
    advertiserId(newVal) {
      if (newVal && newVal !== this.queryForm.advertiserId) {
        this.queryForm.advertiserId = newVal
        if (this.hasLoadedOnce) {
          this.handleQuery()
        }
      }
    }
  },

  computed: {
    reviewStats() {
      return this.tableData.reduce((stats, row) => {
        const summary = row.reviewSummary
        if (!summary) return stats
        stats.passed += Number(summary.passed || 0)
        stats.rejected += Number(summary.rejected || 0)
        stats.pending += Number(summary.pending || 0)
        stats.partial += Number(summary.partial || 0)
        stats.unknown += Number(summary.unknown || 0)
        stats.noAdMaterial += Number(summary.noAdMaterial || 0)
        return stats
      }, {
        passed: 0,
        rejected: 0,
        pending: 0,
        partial: 0,
        unknown: 0,
        noAdMaterial: 0
      })
    },

    assignSummary() {
      if (this.selectedVideos.length === 0) return ''

      const videoCount = this.selectedVideos.length
      const adgroupCount = this.assignForm.adgroupIds.length

      if (adgroupCount === 0) return ''

      if (this.assignForm.assignType === 'average') {
        const perAd = Math.floor(videoCount / adgroupCount)
        const remainder = videoCount % adgroupCount

        if (perAd === 0) {
          return `⚠️ 视频数量不足！当前 ${videoCount} 个视频无法平均分配到 ${adgroupCount} 个广告组（至少需要 ${adgroupCount} 个视频）`
        }

        let summary = `将 ${videoCount} 个视频平均分配到 ${adgroupCount} 个广告组`
        if (remainder === 0) {
          summary += `，每组 ${perAd} 个视频`
        } else {
          summary += `，前 ${remainder} 组 ${perAd + 1} 个，其余 ${perAd} 个`
        }
        return summary
      } else {
        return `将 ${videoCount} 个视频复制到 ${adgroupCount} 个广告组，每个广告组获得全部 ${videoCount} 个视频（共 ${videoCount * adgroupCount} 个视频副本）`
      }
    }
  },

  methods: {
    // 获取视频缩略图（使用封面图）
    getVideoThumbnail(row) {
      if (!row) return ''
      
      // 优先使用videoCoverUrl
      if (row.videoCoverUrl) {
        return row.videoCoverUrl
      }
      
      // 其次使用previewUrl作为降级方案
      if (row.previewUrl) {
        return row.previewUrl
      }
      
      return ''
    },

    // 处理图片加载错误
    handleImageError(event, row) {
      console.warn('图片加载失败:', event.target.src, row)
      // 设置默认占位图
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjVmN2ZhIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxMiIgZmlsbD0iIzkwOTM5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPuWbvuS/oeaBrzwvdGV4dD48L3N2Zz4='
    },

    // 判断缩略图是否正在播放
    isThumbnailPlaying(index) {
      return this.playingThumbnailIndex === index
    },

    // 处理缩略图hover事件
    handleThumbnailHover(event, row, isEnter) {
      if (!row.previewUrl) return
      
      const index = this.tableData.indexOf(row)
      if (index === -1) return
      
      if (isEnter) {
        // 鼠标进入，开始播放
        this.playingThumbnailIndex = index
      } else {
        // 鼠标离开，停止播放
        this.playingThumbnailIndex = null
      }
    },

    // 判断卡片是否正在播放
    isCardPlaying(index) {
      return this.playingCardIndex === index
    },

    // 处理卡片hover事件
    handleCardHover(event, row, isEnter) {
      if (!row.previewUrl) return
      
      const index = this.tableData.indexOf(row)
      if (index === -1) return
      
      if (isEnter) {
        // 鼠标进入，开始播放
        this.playingCardIndex = index
      } else {
        // 鼠标离开，停止播放
        this.playingCardIndex = null
      }
    },

    // 检查是否已存在某种类型的筛选
    hasFilter(type) {
      return this.advancedFilters.some(f => f.type === type)
    },

    // 添加筛选条件
    handleAddFilter(command) {
      const filterMap = {
        cost: { type: 'cost', minValue: null, maxValue: null },
        roas: { type: 'roas', minValue: null, maxValue: null },
        impressions: { type: 'impressions', value: null },
        keyword: { type: 'keyword', value: '' },
        sortBy: { type: 'sortBy', value: 'lifetimeCost' },
        order: { type: 'order', value: 'desc' }
      }

      if (filterMap[command] && !this.hasFilter(command)) {
        this.advancedFilters.push({ ...filterMap[command] })
      }
    },

    // 删除筛选条件
    removeAdvancedFilter(index) {
      this.advancedFilters.splice(index, 1)
    },
    async loadFolderList() {
      try {
        const response = await axios.get(
            `${this.baseUrl}/upload-folder/list`,
            {
              withCredentials: false,
              timeout: 10000
            }
        )

        if (response.data.code === 200 || response.data.code === 0) {
          const folders = response.data.data || []

          this.folderList = folders.map(folder => ({
            label: folder.folderName,
            value: folder.folderName
          }))
        } else {
          throw new Error(response.data.message || '获取文件夹列表失败')
        }
      } catch (error) {
        console.error('加载文件夹列表失败', error)
        this.folderList = [
          { label: '找茬', value: '找茬' },
          { label: '脑洞', value: '脑洞' },
          { label: '拼图', value: '拼图' },
          { label: '麻将', value: '麻将' },
          { label: '数独', value: '数独' }
        ]
      }
    },
    async handleQuery() {
      this.loading = true

      try {
        const params = {
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        }

        // 从动态筛选条件中获取值
        const costFilter = this.advancedFilters.find(f => f.type === 'cost')
        const roasFilter = this.advancedFilters.find(f => f.type === 'roas')
        const impressionsFilter = this.advancedFilters.find(f => f.type === 'impressions')
        const keywordFilter = this.advancedFilters.find(f => f.type === 'keyword')
        const sortByFilter = this.advancedFilters.find(f => f.type === 'sortBy')
        const orderFilter = this.advancedFilters.find(f => f.type === 'order')

        // 检查是否使用了性能数据相关的查询条件
        const hasPerformanceFilter =
            (costFilter && (costFilter.minValue !== null || costFilter.maxValue !== null)) ||
            (roasFilter && (roasFilter.minValue !== null || roasFilter.maxValue !== null)) ||
            (impressionsFilter && impressionsFilter.value !== null) ||
            (keywordFilter && keywordFilter.value) ||
            sortByFilter ||
            orderFilter

        if (hasPerformanceFilter) {
          // 使用性能数据查询接口
          if (this.queryForm.uploadType) {
            params.upload_video_type = this.queryForm.uploadType
          }

          if (this.queryForm.uploadPerson) {
            params.upload_person = this.queryForm.uploadPerson
          }

          // 消耗范围
          if (costFilter) {
            if (costFilter.minValue !== null && costFilter.minValue !== undefined) {
              params.min_cost = costFilter.minValue
            }
            if (costFilter.maxValue !== null && costFilter.maxValue !== undefined) {
              params.max_cost = costFilter.maxValue
            }
          }

          // ROAS范围
          if (roasFilter) {
            if (roasFilter.minValue !== null && roasFilter.minValue !== undefined) {
              params.min_roas = roasFilter.minValue
            }
            if (roasFilter.maxValue !== null && roasFilter.maxValue !== undefined) {
              params.max_roas = roasFilter.maxValue
            }
          }

          // 最小展示
          if (impressionsFilter && impressionsFilter.value !== null && impressionsFilter.value !== undefined) {
            params.min_impressions = impressionsFilter.value
          }

          // 关键词
          if (keywordFilter && keywordFilter.value) {
            params.keyword = keywordFilter.value
          }

          // 排序
          params.sort_by = sortByFilter ? sortByFilter.value : 'lifetime_cost'
          params.order = orderFilter ? orderFilter.value : 'desc'

          const response = await axios.get(
              `https://tiktoktf.darknight.games/api/api/material/lifetime/query`,
              {
                params,
                withCredentials: false,
                timeout: 30000
              }
          )

          if (response.data.code === 200 || response.data.code === 0) {
            const data = response.data.data

            // 适配 lifetime 接口返回的数据结构
            const records = (data.list || []).map(item => ({
              ...item,
              // 映射字段以保持兼容性
              id: item.videoUploadRecordId || item.uploadRecordId || item.recordId || null,
              lifetimeId: item.id,
              materialId: item.materialId,
              videoId: item.videoId,
              fileName: item.fileName,
              originalFileName: item.originalFileName,
              imageId: item.imageId,
              uploadVideoType: item.uploadVideoType,
              uploadPerson: item.uploadPerson,
              adUsageRecords: item.adUsageRecords,
              width: item.width,
              height: item.height,
              duration: item.duration,
              previewUrl: item.previewUrl,
              videoCoverUrl: item.videoCoverUrl,
              // 性能数据字段
              lifetimeCost: item.lifetimeCost,
              lifetimeImpressions: item.lifetimeImpressions,
              lifetimeClicks: item.lifetimeClicks,
              lifetimeConversions: item.lifetimeConversions,
              lifetimeRevenue: item.lifetimeRevenue,
              lifetimeRoas: item.lifetimeRoas,
              lifetimeCtr: item.lifetimeCtr,
              lifetimeCpc: item.lifetimeCpc,
              lifetimeCpm: item.lifetimeCpm,
              lifetimeConversionRate: item.lifetimeConversionRate,
              totalAdvertiserCount: item.totalAdvertiserCount,
              firstUsedDate: item.firstUsedDate,
              lastActiveDate: item.lastActiveDate,
              activeDays: item.activeDays
            }))

            this.tableData = records

            this.restoreSelectionState()

            // 适配分页数据结构
            this.pagination = {
              page: data.page,
              pageSize: this.pagination.pageSize,
              totalElements: data.total,
              totalPages: data.total_pages,
              hasNext: data.page < data.total_pages,
              hasPrevious: data.page > 1
            }
          } else {
            throw new Error(response.data.message || '查询失败')
          }
        } else {
          // 使用原有的视频记录查询接口
          params.advertiser_id = "7598883753192357896"

          if (this.queryForm.uploadPerson) {
            params.upload_person = this.queryForm.uploadPerson
          }

          if (this.queryForm.uploadType) {
            params.upload_type = this.queryForm.uploadType
          }

          if (this.queryForm.fileName) {
            params.file_name = this.queryForm.fileName
          }

          if (this.queryForm.startDate) {
            params.start_date = this.queryForm.startDate
          }

          if (this.queryForm.endDate) {
            params.end_date = this.queryForm.endDate
          }

          const response = await axios.get(
              `${this.baseUrl}/tiktok/video/v2/records`,
              {
                params,
                withCredentials: false,
                timeout: 30000
              }
          )

          if (response.data.code === 200 || response.data.code === 0) {
            const data = response.data.data
            this.tableData = data.records || []

            this.restoreSelectionState()

            this.pagination = {
              page: data.page,
              pageSize: data.pageSize,
              totalElements: data.totalElements,
              totalPages: data.totalPages,
              hasNext: data.hasNext,
              hasPrevious: data.hasPrevious
            }
          } else {
            throw new Error(response.data.message || '查询失败')
          }
        }
        
        // 查询成功后保存查询条件到 localStorage
        this.saveQueryFormToStorage()
      } catch (error) {
        console.error('查询视频记录失败', error)
        this.$message.error('查询失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },
// ... existing code ...


    restoreSelectionState() {
      this.tableData.forEach(row => {
        if (row.videoId && row.imageId && this.selectedVideoIds.has(row.videoId)) {
          row._selected = true
          if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
            this.selectedVideos.push(row)
          }
        } else {
          row._selected = false
        }
      })
    },
    async refreshCurrentPageMaterialReview() {
      const payload = this.buildMaterialReviewPayload(this.tableData)
      if (payload.videoRecordIds.length === 0 && payload.materialIds.length === 0 && payload.videoIds.length === 0) {
        this.$message.warning('当前页缺少可查询的素材标识')
        return
      }

      this.materialReviewLoading = true
      try {
        const response = await axios.post(
            `${this.baseUrl}/smart-plus/material/review-info`,
            payload,
            {
              withCredentials: false,
              timeout: 60000
            }
        )

        if (response.data.code !== 200 && response.data.code !== 0) {
          throw new Error(response.data.message || '刷新审核统计失败')
        }

        const data = response.data.data || {}
        this.applyMaterialReviewSummaries(this.tableData, data.sourceSummaries || [])
        this.$message.success(`审核统计已刷新：通过 ${data.passed || 0}，失败 ${data.rejected || 0}`)
      } catch (error) {
        console.error('刷新审核统计失败', error)
        this.$message.error('刷新审核统计失败: ' + error.message)
      } finally {
        this.materialReviewLoading = false
      }
    },
    buildMaterialReviewPayload(rows) {
      return {
        videoRecordIds: [...new Set((rows || []).map(row => row.id).filter(Boolean))],
        materialIds: [...new Set((rows || []).map(row => row.materialId).filter(Boolean))],
        videoIds: [...new Set((rows || []).map(row => row.videoId).filter(Boolean))],
        includeRejectInfo: true
      }
    },
    applyMaterialReviewSummaries(rows, summaries) {
      const summaryMap = new Map()
      ;(summaries || []).forEach(summary => {
        if (summary.sourceRecordId) summaryMap.set(`record:${summary.sourceRecordId}`, summary)
        if (summary.sourceUploadMaterialId) summaryMap.set(`material:${summary.sourceUploadMaterialId}`, summary)
        if (summary.sourceVideoId) summaryMap.set(`video:${summary.sourceVideoId}`, summary)
      })

      rows.forEach(row => {
        const summary = summaryMap.get(`record:${row.id}`) ||
            summaryMap.get(`material:${row.materialId}`) ||
            summaryMap.get(`video:${row.videoId}`) ||
            { total: 0, passed: 0, rejected: 0, pending: 0, partial: 0, unknown: 0, noAdMaterial: 1 }
        this.$set(row, 'reviewSummary', summary)
      })
    },
    getReviewTagType(row) {
      const summary = row.reviewSummary
      if (!summary) return 'info'
      if (Number(summary.rejected || 0) > 0) return 'danger'
      if (Number(summary.pending || 0) > 0) return 'warning'
      if (Number(summary.passed || 0) > 0) return 'success'
      return 'info'
    },
    getReviewSummaryText(row) {
      const summary = row.reviewSummary
      if (!summary) return '未刷新'
      return `过${summary.passed || 0}/败${summary.rejected || 0}/审${summary.pending || 0}`
    },
    handleReset() {
      this.queryForm.advertiserId = ''
      this.queryForm.uploadPerson = ''
      this.queryForm.uploadType = ''
      this.queryForm.fileName = ''
      this.queryForm.startDate = ''
      this.queryForm.endDate = ''

      // 清空所有高级筛选条件
      this.advancedFilters = []

      this.pagination.page = 1
      this.handleQuery()
      
      // 重置时清除 localStorage
      this.clearQueryFormFromStorage()
    },
    handleRefresh() {
      this.pagination.page = 1
      this.handleQuery()
    },

    getCurrentUsername() {
      return this.$store.state.username || this.$store.state.user?.username || ''
    },

    buildDeleteSummary(videos) {
      const names = videos
          .map(row => row.fileName || row.originalFileName || `ID ${row.id}`)
          .filter(Boolean)
      const previewNames = names.slice(0, 5).join('、')
      const moreText = names.length > 5 ? ` 等 ${names.length} 个视频` : ''
      const usedCount = videos.filter(row =>
          Number(row.useCount || row.totalUseCount || row.totalAdvertiserCount || 0) > 0
      ).length
      const usedText = usedCount > 0 ? `\n其中 ${usedCount} 个视频已有投放或使用记录，删除后只会从当前视频库隐藏。` : ''
      return `将删除 ${videos.length} 个视频：${previewNames}${moreText}${usedText}\n删除原因可不填。`
    },

    async confirmDeleteVideos(videos) {
      const validVideos = (videos || []).filter(row => row && row.id)
      if (validVideos.length === 0) {
        this.$message.warning('没有可删除的视频记录')
        return
      }

      try {
        const result = await this.$prompt(
            this.buildDeleteSummary(validVideos),
            '确认删除视频',
            {
              confirmButtonText: '删除',
              cancelButtonText: '取消',
              inputType: 'textarea',
              inputPlaceholder: '删除原因（可选）',
              inputValidator: value => !value || value.length <= 500 || '删除原因不能超过 500 字',
              confirmButtonClass: 'el-button--danger'
            }
        )
        await this.deleteVideos(validVideos, result.value || '')
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          this.$message.error('删除取消或失败')
        }
      }
    },

    async deleteVideos(videos, reason) {
      const ids = Array.from(new Set(videos.map(row => row.id).filter(Boolean)))
      if (ids.length === 0) {
        this.$message.warning('没有可删除的视频记录')
        return
      }

      this.deleteLoading = true
      try {
        const response = await axios.post(
            `${this.baseUrl}/tiktok/video/v2/records/delete`,
            {
              ids,
              deletedBy: this.getCurrentUsername(),
              reason
            },
            {
              withCredentials: false,
              timeout: 30000
            }
        )

        if (response.data.code !== 200 && response.data.code !== 0) {
          throw new Error(response.data.message || '删除失败')
        }

        const result = response.data.data || {}
        this.removeDeletedSelection(ids)
        await this.handleQuery()
        if (this.deleteRecordDialogVisible) {
          await this.loadDeletedRecords()
        }

        const failedCount = (result.failedIds || []).length
        const skippedCount = result.skippedCount || 0
        this.$message.success(`删除成功 ${result.deletedCount || 0} 个${skippedCount ? `，跳过 ${skippedCount} 个` : ''}${failedCount ? `，失败 ${failedCount} 个` : ''}`)
      } catch (error) {
        console.error('删除视频失败', error)
        this.$message.error('删除失败: ' + error.message)
      } finally {
        this.deleteLoading = false
      }
    },

    removeDeletedSelection(ids) {
      const idSet = new Set(ids.map(id => String(id)))
      const deletedVideoIds = new Set(
          this.selectedVideos
              .filter(row => idSet.has(String(row.id)))
              .map(row => row.videoId)
              .filter(Boolean)
      )

      this.selectedVideos = this.selectedVideos.filter(row => !idSet.has(String(row.id)))
      this.selectedVideoIds.clear()
      this.selectedVideos.forEach(row => {
        if (row.videoId) {
          this.selectedVideoIds.add(row.videoId)
        }
      })
      this.tableData.forEach(row => {
        if (idSet.has(String(row.id)) || (row.videoId && deletedVideoIds.has(row.videoId))) {
          row._selected = false
        }
      })
    },

    handleDeleteVideo(row) {
      this.confirmDeleteVideos([row])
    },

    handleBatchDelete() {
      this.confirmDeleteVideos(this.selectedVideos)
    },

    openDeletedRecordsDialog() {
      this.deleteRecordDialogVisible = true
      this.deletedRecordPagination.page = 1
      this.loadDeletedRecords()
    },

    async loadDeletedRecords() {
      this.deletedRecordLoading = true
      try {
        const params = {
          page: this.deletedRecordPagination.page,
          page_size: this.deletedRecordPagination.pageSize
        }

        if (this.deletedRecordQuery.uploadPerson) {
          params.upload_person = this.deletedRecordQuery.uploadPerson
        }
        if (this.deletedRecordQuery.fileName) {
          params.file_name = this.deletedRecordQuery.fileName
        }

        const response = await axios.get(
            `${this.baseUrl}/tiktok/video/v2/records/deleted`,
            {
              params,
              withCredentials: false,
              timeout: 30000
            }
        )

        if (response.data.code !== 200 && response.data.code !== 0) {
          throw new Error(response.data.message || '查询删除记录失败')
        }

        const data = response.data.data || {}
        this.deletedRecords = data.records || []
        this.deletedRecordPagination = {
          page: data.page || this.deletedRecordPagination.page,
          pageSize: data.pageSize || this.deletedRecordPagination.pageSize,
          totalElements: data.totalElements || 0,
          totalPages: data.totalPages || 0
        }
      } catch (error) {
        console.error('查询删除记录失败', error)
        this.$message.error('查询删除记录失败: ' + error.message)
      } finally {
        this.deletedRecordLoading = false
      }
    },

    handleDeletedRecordPageChange(page) {
      this.deletedRecordPagination.page = page
      this.loadDeletedRecords()
    },

    handleDeletedRecordSizeChange(size) {
      this.deletedRecordPagination.pageSize = size
      this.deletedRecordPagination.page = 1
      this.loadDeletedRecords()
    },

    resetDeletedRecordQuery() {
      this.deletedRecordQuery.uploadPerson = ''
      this.deletedRecordQuery.fileName = ''
      this.deletedRecordPagination.page = 1
      this.loadDeletedRecords()
    },

    handlePageChange(page) {
      this.pagination.page = page
      this.handleQuery()
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.handleQuery()
    },

    // 保存查询条件到 localStorage
    saveQueryFormToStorage() {
      try {
        const storageData = {
          queryForm: {
            uploadPerson: this.queryForm.uploadPerson,
            uploadType: this.queryForm.uploadType,
            fileName: this.queryForm.fileName,
            startDate: this.queryForm.startDate,
            endDate: this.queryForm.endDate
          },
          advancedFilters: this.advancedFilters,
          pagination: {
            pageSize: this.pagination.pageSize
          },
          viewMode: this.viewMode,
          timestamp: Date.now()
        }
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(storageData))
      } catch (error) {
        console.error('保存查询条件失败', error)
      }
    },

    // 从 localStorage 加载查询条件
    loadQueryFormFromStorage() {
      try {
        const stored = localStorage.getItem(this.STORAGE_KEY)
        if (stored) {
          const storageData = JSON.parse(stored)
          
          // 恢复基础查询条件
          if (storageData.queryForm) {
            Object.assign(this.queryForm, storageData.queryForm)
          }
          
          // 恢复高级筛选条件
          if (storageData.advancedFilters && Array.isArray(storageData.advancedFilters)) {
            this.advancedFilters = storageData.advancedFilters
          }
          
          // 恢复分页大小
          if (storageData.pagination && storageData.pagination.pageSize) {
            this.pagination.pageSize = storageData.pagination.pageSize
          }
          
          // 恢复视图模式
          if (storageData.viewMode && ['table', 'card', 'thumbnail', 'list'].includes(storageData.viewMode)) {
            this.viewMode = storageData.viewMode
          }
          
          console.log('已从本地存储恢复查询条件')
        }
      } catch (error) {
        console.error('加载查询条件失败', error)
      }
    },

    // 清除 localStorage 中的查询条件
    clearQueryFormFromStorage() {
      try {
        localStorage.removeItem(this.STORAGE_KEY)
      } catch (error) {
        console.error('清除查询条件失败', error)
      }
    },

    handlePreview(row) {
      this.previewUrl = row.previewUrl
      this.previewVisible = true
    },
    async handleViewTrend(row) {
      const fileName = row.fileName || row.originalFileName
      if (!fileName) {
        this.$message.warning('该素材没有文件名，无法查询趋势')
        return
      }

      this.trendDialogVisible = true
      this.trendLoading = true
      this.trendData = null

      try {
        const response = await axios.get(
            `https://tiktoktf.darknight.games/api/api/material/lifetime/daily-stats/${encodeURIComponent(fileName)}`,
            {
              withCredentials: false,
              timeout: 30000
            }
        )

        if (response.data.code === 200 || response.data.code === 0) {
          this.trendData = response.data.data

          if (!this.trendData.daily_stats || this.trendData.daily_stats.length === 0) {
            this.$message.info('该素材暂无15天趋势数据')
          }
        } else {
          throw new Error(response.data.message || '查询失败')
        }
      } catch (error) {
        console.error('查询趋势数据失败', error)
        this.$message.error('查询趋势数据失败: ' + error.message)
      } finally {
        this.trendLoading = false
      }
    },

    handleCopyInfo(row) {
      const info = `文件名: ${row.fileName}
视频ID: ${row.videoId || '无'}
素材ID: ${row.materialId || '无'}
状态: ${this.getStatusText(row.uploadStatus)}`

      this.copyToClipboard(info)
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success('已复制到剪贴板')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    },

    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return '-'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i]
    },

    formatDuration(seconds) {
      if (!seconds) return '-'
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${mins}:${secs.toString().padStart(2, '0')}`
    },

    formatTime(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },

    getStatusType(status) {
      const types = {
        'SUCCESS': 'success',
        'FAILED': 'danger',
        'UPLOADING': 'warning',
        'PENDING': 'info'
      }
      return types[status] || 'info'
    },

    getStatusText(status) {
      const texts = {
        'SUCCESS': '成功',
        'FAILED': '失败',
        'UPLOADING': '上传中',
        'PENDING': '等待中'
      }
      return texts[status] || status
    },

    handleSelectionChange(selection) {
      // 获取当前页的所有视频ID
      const currentPageIds = new Set(this.tableData.map(row => row.videoId).filter(Boolean))

      // 1. 从selectedVideos中移除当前页已取消选中的视频
      this.selectedVideos = this.selectedVideos.filter(v => {
        if (currentPageIds.has(v.videoId)) {
          // 如果该视频在当前页，检查是否还在selection中
          return selection.some(s => s.videoId === v.videoId)
        }
        // 不在当前页的视频保留
        return true
      })

      // 2. 更新selectedVideoIds集合
      this.selectedVideoIds.clear()
      this.selectedVideos.forEach(v => this.selectedVideoIds.add(v.videoId))

      // 3. 将当前页新选中的视频添加到selectedVideos
      selection.forEach(row => {
        if (row.videoId && row.imageId) {
          this.selectedVideoIds.add(row.videoId)
          if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
            this.selectedVideos.push(row)
          }
        }
      })
    },

    handleCardSelectionChange(row) {
      if (row.videoId && row.imageId) {
        if (row._selected) {
          this.selectedVideoIds.add(row.videoId)
          if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
            this.selectedVideos.push(row)
          }
        } else {
          this.selectedVideoIds.delete(row.videoId)
          const index = this.selectedVideos.findIndex(v => v.videoId === row.videoId)
          if (index !== -1) {
            this.selectedVideos.splice(index, 1)
          }
        }
      } else {
        row._selected = false
        this.$message.warning('该视频缺少必要信息（videoId或imageId），无法选择')
      }
    },

    isVideoSelected(row) {
      return row.videoId && row.imageId && this.selectedVideoIds.has(row.videoId)
    },

    isSelectingCard(row) {
      if (!this.isDragging || !row.videoId || !row.imageId) {
        return false
      }

      const index = this.tableData.indexOf(row)
      const cardElement = document.querySelector(`.video-card[data-index="${index}"]`)
      if (!cardElement) return false

      const cardRect = cardElement.getBoundingClientRect()
      const containerRect = this.$refs.cardViewContainer.getBoundingClientRect()

      const selectionLeft = Math.min(this.dragStartX, this.dragCurrentX)
      const selectionRight = Math.max(this.dragStartX, this.dragCurrentX)
      const selectionTop = Math.min(this.dragStartY, this.dragCurrentY)
      const selectionBottom = Math.max(this.dragStartY, this.dragCurrentY)

      const cardLeft = cardRect.left - containerRect.left
      const cardRight = cardLeft + cardRect.width
      const cardTop = cardRect.top - containerRect.top
      const cardBottom = cardTop + cardRect.height

      const isIntersecting = !(cardRight < selectionLeft ||
               cardLeft > selectionRight ||
               cardBottom < selectionTop ||
               cardTop > selectionBottom)

      return isIntersecting
    },

    handleSelectAllOnPage() {
      this.tableData.forEach(row => {
        if (row.videoId && row.imageId) {
          row._selected = true
          this.selectedVideoIds.add(row.videoId)
          if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
            this.selectedVideos.push(row)
          }
        }
      })

      const selectableCount = this.tableData.filter(row => row.videoId && row.imageId).length
      if (selectableCount > 0) {
        this.$message.success(`已选中当前页 ${selectableCount} 个符合条件的视频`)
      } else {
        this.$message.warning('当前页没有符合条件的视频（需同时包含videoId和imageId）')
      }
    },

    checkSelectable(row) {
      return !!(row.videoId && row.imageId)
    },

    handleClearSelection() {
      this.selectedVideos = []
      this.selectedVideoIds.clear()
      this.tableData.forEach(row => {
        row._selected = false
      })
    },

    async handleAssignToAds() {
      if (this.selectedVideos.length === 0) {
        this.$message.warning('请先选择要分配的视频')
        return
      }

      this.assignDialogVisible = true
    },

    confirmAssign() {
      if (this.selectedVideos.length === 0) {
        this.$message.warning('请先选择要分配的视频')
        return
      }

      const videos = this.selectedVideos.map(v => ({
        dbRecordId: v.id,
        id: v.id,
        lifetimeId: v.lifetimeId,
        advertiserId: v.advertiserId || this.queryForm.advertiserId || this.advertiserId,
        materialId: v.materialId,
        videoId: v.videoId,
        imageId: v.imageId,
        videoCoverUrl: v.videoCoverUrl || '',
        previewUrl: v.previewUrl || '',
        originalFileName: v.originalFileName,
        uploadVideoType: v.uploadVideoType,
        uploadPerson: v.uploadPerson,
        adUsageRecords: v.adUsageRecords,
        creative_info: {
          ad_format: 'SINGLE_VIDEO',
          video_info: {
            video_id: v.videoId,
            video_cover_url: v.videoCoverUrl || '',
            preview_url: v.previewUrl || ''
          },
          image_info: [{
            web_uri: v.imageId
          }],
          identity_type: "BC_AUTH_TT",
          identity_id: "1d955ad7-cceb-539d-97e5-875db5b789f9",
          identity_authorized_bc_id: "7596985632614989825"
        },
        selected: true,
        file_name: v.fileName || v.originalFileName || 'video.mp4'
      }))

      const result = {
        videos: videos,
        timestamp: new Date().getTime()
      }

      console.log('传递视频数据给父组件:', result)

      this.$emit('videos-assigned', result)

      this.assignDialogVisible = false
      // this.handleClearSelection()

      this.$message.success(`已将 ${this.selectedVideos.length} 个视频传递给父组件`)
    },

    handleMouseDown(e) {
      if (e.button !== 0) return

      if (!e.target.closest('.card-view')) return

      const container = this.$refs.cardViewContainer
      if (!container) return

      const rect = container.getBoundingClientRect()
      this.dragStartX = e.clientX - rect.left
      this.dragStartY = e.clientY - rect.top
      this.dragCurrentX = this.dragStartX
      this.dragCurrentY = this.dragStartY
      this.isDragging = true

      // if (!e.ctrlKey && !e.metaKey) {
      //   this.handleClearSelection()
      // }

      e.preventDefault()
    },

    handleMouseMove(e) {
      if (!this.isDragging) return

      const container = this.$refs.cardViewContainer
      if (!container) return

      const rect = container.getBoundingClientRect()
      this.dragCurrentX = e.clientX - rect.left
      this.dragCurrentY = e.clientY - rect.top

      const left = Math.min(this.dragStartX, this.dragCurrentX)
      const top = Math.min(this.dragStartY, this.dragCurrentY)
      const width = Math.abs(this.dragCurrentX - this.dragStartX)
      const height = Math.abs(this.dragCurrentY - this.dragStartY)

      this.selectionBoxStyle = {
        left: left + 'px',
        top: top + 'px',
        width: width + 'px',
        height: height + 'px'
      }
    },

    handleMouseUp(e) {
      if (!this.isDragging) return

      const selectedInDrag = []

      this.tableData.forEach((row, index) => {
        if (!row.videoId || !row.imageId) return

        if (this.isSelectingCard(row)) {
          row._selected = true
          this.selectedVideoIds.add(row.videoId)
          if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
            this.selectedVideos.push(row)
            selectedInDrag.push(row)
          }
        }
      })

      this.isDragging = false
      this.selectionBoxStyle = {
        left: '0px',
        top: '0px',
        width: '0px',
        height: '0px'
      }

      if (selectedInDrag.length > 0) {
        this.$message.success(`已选中 ${selectedInDrag.length} 个视频`)
      }
    },

    handleThumbnailClick(row) {
      if (!row.imageId) {
        this.$message.warning('该视频缺少封面ID，无法选择')
        return
      }
      this.toggleCardSelection(row)
    }, handleFileItemClick(row) {
      if (!row.imageId) {
        this.$message.warning('该视频缺少封面ID，无法选择')
        return
      }
      this.toggleCardSelection(row)
    },

    toggleCardSelection(row) {
      if (!row.videoId || !row.imageId) {
        row._selected = false
        return
      }

      row._selected = !row._selected

      if (row._selected) {
        this.selectedVideoIds.add(row.videoId)
        if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
          this.selectedVideos.push(row)
        }
      } else {
        this.selectedVideoIds.delete(row.videoId)
        const index = this.selectedVideos.findIndex(v => v.videoId === row.videoId)
        if (index !== -1) {
          this.selectedVideos.splice(index, 1)
        }
      }
    },

    handleVideoHover(event, isEnter) {
      const video = event.target
      if (isEnter) {
        video.play().catch(() => {
          // 自动播放失败时静默处理
        })
      } else {
        video.pause()
        video.currentTime = 0
      }
    },

    truncate(str, len) {
      if (!str) return ''
      return str.length > len ? str.substring(0, len) + '...' : str
    },

    // 判断是否为新上传视频（use_count为0且上传日期为今天）
    isNewVideo(row) {
      const useCount = row.useCount || row.use_count
      const recordCreatedAt = row.recordCreatedAt

      // use_count 不为 0 则不是上新
      if (useCount !== 0 && useCount !== undefined) {
        return false
      }

      // 检查上传日期是否为今天
      if (recordCreatedAt) {
        const uploadDate = new Date(recordCreatedAt)
        const today = new Date()

        return uploadDate.getFullYear() === today.getFullYear() &&
               uploadDate.getMonth() === today.getMonth() &&
               uploadDate.getDate() === today.getDate()
      }

      return false
    },
    handleThumbnailMouseDown(e) {
      if (e.button !== 0) return

      if (!e.target.closest('.thumbnail-view')) return

      const container = this.$refs.thumbnailViewContainer
      if (!container) return

      const rect = container.getBoundingClientRect()
      this.thumbnailDragStartX = e.clientX - rect.left
      this.thumbnailDragStartY = e.clientY - rect.top
      this.thumbnailDragCurrentX = this.thumbnailDragStartX
      this.thumbnailDragCurrentY = this.thumbnailDragStartY
      this.isDraggingThumbnail = true
      this.thumbnailClickTarget = e.target.closest('.thumbnail-item')

      e.preventDefault()

      window.addEventListener('mouseup', this.handleThumbnailMouseUp)
      window.addEventListener('mousemove', this.handleThumbnailMouseMove)
    },

    handleThumbnailMouseMove(e) {
      if (!this.isDraggingThumbnail) return

      const container = this.$refs.thumbnailViewContainer
      if (!container) return

      const rect = container.getBoundingClientRect()
      this.thumbnailDragCurrentX = e.clientX - rect.left
      this.thumbnailDragCurrentY = e.clientY - rect.top

      const left = Math.min(this.thumbnailDragStartX, this.thumbnailDragCurrentX)
      const top = Math.min(this.thumbnailDragStartY, this.thumbnailDragCurrentY)
      const width = Math.abs(this.thumbnailDragCurrentX - this.thumbnailDragStartX)
      const height = Math.abs(this.thumbnailDragCurrentY - this.thumbnailDragStartY)

      this.thumbnailSelectionBoxStyle = {
        left: left + 'px',
        top: top + 'px',
        width: width + 'px',
        height: height + 'px'
      }
    },

    handleThumbnailMouseUp(e) {
      if (!this.isDraggingThumbnail) return

      const dragDistance = Math.sqrt(
          Math.pow(this.thumbnailDragCurrentX - this.thumbnailDragStartX, 2) +
          Math.pow(this.thumbnailDragCurrentY - this.thumbnailDragStartY, 2)
      )

      const isClick = dragDistance < 5

      if (isClick && this.thumbnailClickTarget) {
        const index = parseInt(this.thumbnailClickTarget.getAttribute('data-index'))
        if (!isNaN(index) && this.tableData[index]) {
          const row = this.tableData[index]
          if (row.imageId) {
            this.toggleCardSelection(row)
          } else {
            this.$message.warning('该视频缺少封面ID，无法选择')
          }
        }
      } else if (!isClick) {
        const selectedInDrag = []

        this.tableData.forEach((row, index) => {
          if (!row.videoId || !row.imageId) return

          if (this.isSelectingThumbnail(row)) {
            row._selected = true
            this.selectedVideoIds.add(row.videoId)
            if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
              this.selectedVideos.push(row)
              selectedInDrag.push(row)
            }
          }
        })

        if (selectedInDrag.length > 0) {
          this.$message.success(`已选中 ${selectedInDrag.length} 个视频`)
        }
      }

      this.isDraggingThumbnail = false
      this.thumbnailSelectionBoxStyle = {
        left: '0px',
        top: '0px',
        width: '0px',
        height: '0px'
      }
      this.thumbnailClickTarget = null

      window.removeEventListener('mouseup', this.handleThumbnailMouseUp)
      window.removeEventListener('mousemove', this.handleThumbnailMouseMove)
    },

    isSelectingThumbnail(row) {
      if (!this.isDraggingThumbnail || !row.videoId || !row.imageId) {
        return false
      }

      const index = this.tableData.indexOf(row)
      const thumbnailElement = document.querySelector(`.thumbnail-item[data-index="${index}"]`)
      if (!thumbnailElement) return false

      const thumbnailRect = thumbnailElement.getBoundingClientRect()
      const containerRect = this.$refs.thumbnailViewContainer.getBoundingClientRect()

      const selectionLeft = Math.min(this.thumbnailDragStartX, this.thumbnailDragCurrentX)
      const selectionRight = Math.max(this.thumbnailDragStartX, this.thumbnailDragCurrentX)
      const selectionTop = Math.min(this.thumbnailDragStartY, this.thumbnailDragCurrentY)
      const selectionBottom = Math.max(this.thumbnailDragStartY, this.thumbnailDragCurrentY)

      const thumbnailLeft = thumbnailRect.left - containerRect.left
      const thumbnailRight = thumbnailLeft + thumbnailRect.width
      const thumbnailTop = thumbnailRect.top - containerRect.top
      const thumbnailBottom = thumbnailTop + thumbnailRect.height

      const isIntersecting = !(thumbnailRight < selectionLeft ||
          thumbnailLeft > selectionRight ||
          thumbnailBottom < selectionTop ||
          thumbnailTop > selectionBottom)

      return isIntersecting
    },
    handleListMouseDown(e) {
      if (e.button !== 0) return
      if (!e.target.closest('.list-view')) return

      const container = this.$refs.listViewContainer
      if (!container) return

      const rect = container.getBoundingClientRect()
      this.listDragStartX = e.clientX - rect.left
      this.listDragStartY = e.clientY - rect.top
      this.listDragCurrentX = this.listDragStartX
      this.listDragCurrentY = this.listDragStartY
      this.isDraggingList = true
      this.listClickTarget = e.target.closest('.file-item')

      e.preventDefault()

      window.addEventListener('mouseup', this.handleListMouseUp)
      window.addEventListener('mousemove', this.handleListMouseMove)
    },

    handleListMouseMove(e) {
      if (!this.isDraggingList) return

      const container = this.$refs.listViewContainer
      if (!container) return

      const rect = container.getBoundingClientRect()
      this.listDragCurrentX = e.clientX - rect.left
      this.listDragCurrentY = e.clientY - rect.top

      const left = Math.min(this.listDragStartX, this.listDragCurrentX)
      const top = Math.min(this.listDragStartY, this.listDragCurrentY)
      const width = Math.abs(this.listDragCurrentX - this.listDragStartX)
      const height = Math.abs(this.listDragCurrentY - this.listDragStartY)

      this.listSelectionBoxStyle = {
        left: left + 'px',
        top: top + 'px',
        width: width + 'px',
        height: height + 'px'
      }
    },

    handleListMouseUp(e) {
      if (!this.isDraggingList) return

      const dragDistance = Math.sqrt(
          Math.pow(this.listDragCurrentX - this.listDragStartX, 2) +
          Math.pow(this.listDragCurrentY - this.listDragStartY, 2)
      )

      const isClick = dragDistance < 5

      if (isClick && this.listClickTarget) {
        const index = parseInt(this.listClickTarget.getAttribute('data-index'))
        if (!isNaN(index) && this.tableData[index]) {
          const row = this.tableData[index]
          if (row.imageId) {
            this.toggleCardSelection(row)
          } else {
            this.$message.warning('该视频缺少封面ID，无法选择')
          }
        }
      } else if (!isClick) {
        const selectedInDrag = []

        this.tableData.forEach((row, index) => {
          if (!row.videoId || !row.imageId) return

          if (this.isSelectingListItem(row)) {
            row._selected = true
            this.selectedVideoIds.add(row.videoId)
            if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
              this.selectedVideos.push(row)
              selectedInDrag.push(row)
            }
          }
        })

        if (selectedInDrag.length > 0) {
          this.$message.success(`已选中 ${selectedInDrag.length} 个视频`)
        }
      }

      this.isDraggingList = false
      this.listSelectionBoxStyle = {
        left: '0px',
        top: '0px',
        width: '0px',
        height: '0px'
      }
      this.listClickTarget = null

      window.removeEventListener('mouseup', this.handleListMouseUp)
      window.removeEventListener('mousemove', this.handleListMouseMove)
    },

    isSelectingListItem(row) {
      if (!this.isDraggingList || !row.videoId || !row.imageId) {
        return false
      }

      const index = this.tableData.indexOf(row)
      const itemElement = document.querySelector(`.file-item[data-index="${index}"]`)
      if (!itemElement) return false

      const itemRect = itemElement.getBoundingClientRect()
      const containerRect = this.$refs.listViewContainer.getBoundingClientRect()

      const selectionLeft = Math.min(this.listDragStartX, this.listDragCurrentX)
      const selectionRight = Math.max(this.listDragStartX, this.listDragCurrentX)
      const selectionTop = Math.min(this.listDragStartY, this.listDragCurrentY)
      const selectionBottom = Math.max(this.listDragStartY, this.listDragCurrentY)

      const itemLeft = itemRect.left - containerRect.left
      const itemRight = itemLeft + itemRect.width
      const itemTop = itemRect.top - containerRect.top
      const itemBottom = itemTop + itemRect.height

      const isIntersecting = !(itemRight < selectionLeft ||
          itemLeft > selectionRight ||
          itemBottom < selectionTop ||
          itemTop > selectionBottom)

      return isIntersecting
    },


  }
}
</script>

<style scoped>
.video-record-query {
  margin-top: 0;
}

.query-card {
  border-radius: 4px;
}

.query-card >>> .el-card__header {
  padding: 12px 16px;
  border-bottom: 1px solid #e4e7ed;
}

.query-card >>> .el-card__body {
  padding: 12px 16px;
}

.query-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.query-card .card-header h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

.query-card .card-header h3 i {
  margin-right: 8px;
  color: #409EFF;
}

.query-form {
  margin-bottom: 12px;
}

.query-form >>> .el-form-item {
  margin-bottom: 8px;
}

.query-form >>> .el-form-item__label {
  padding-right: 6px;
  font-size: 13px;
}



.stats-bar {
  display: flex;
  align-items: center;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 4px;
  flex-wrap: wrap;
  gap: 8px;
}

.batch-actions {
  margin-top: 16px;
}

.batch-actions .el-alert {
  margin-bottom: 12px;
}

.batch-actions .action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.delete-record-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.delete-record-pagination {
  margin-top: 12px;
  text-align: center;
}

.video-card {
  position: relative;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s;
  user-select: none;
}

.video-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.video-card.selected {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.video-card.selecting {
  border-color: #409EFF;
  background-color: rgba(64, 158, 255, 0.05);
}

.missing-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
}

.missing-badge .el-tag {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 上新标识样式 */
.new-badge {
  position: absolute;
  top: 10px;
  left: 40px;
  z-index: 10;
}

.new-badge .el-tag {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.video-checkbox {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
}

.assign-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}

.assign-tip p {
  margin: 4px 0;
}

.id-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.id-cell .copy-icon {
  cursor: pointer;
  color: #409EFF;
  font-size: 14px;
}

.id-cell .copy-icon:hover {
  color: #66b1ff;
}

.pagination-container {
  margin-top: 12px;
  text-align: center;
}

.card-view {
  margin-top: 12px;
  position: relative;
  min-height: 200px;
}

.video-cards {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  padding: 8px;
}
.card-preview {
  position: relative;
  width: 100%;
  height: 140px;
  background: #000;
  cursor: pointer;
  overflow: hidden;
}

.card-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.card-preview video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.card-preview .play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s;
}

.card-preview:hover .play-overlay {
  opacity: 1;
}

.play-overlay i {
  font-size: 48px;
  color: #fff;
}

.card-preview.no-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #909399;
}

.card-preview.no-preview i {
  font-size: 48px;
  margin-bottom: 8px;
}

.card-content {
  padding: 10px;
}

.card-title {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.review-summary-line {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.card-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 8px;
  position: relative;
}

/* 印章样式 */
.stamp-badge {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%) rotate(-15deg);
  width: 60px;
  height: 60px;
  border: 3px solid #f56c6c;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(245, 108, 108, 0.1);
  z-index: 5;
  animation: stampPulse 2s infinite;
}

.stamp-text {
  font-size: 14px;
  font-weight: bold;
  color: #f56c6c;
  transform: rotate(15deg);
  letter-spacing: 2px;
}

@keyframes stampPulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(245, 108, 108, 0);
  }
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 1.5;
}

.info-item .label {
  color: #909399;
  min-width: 70px;
  flex-shrink: 0;
}

.info-item .value {
  color: #606266;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy-icon-small {
  cursor: pointer;
  color: #409EFF;
  font-size: 12px;
  margin-left: 4px;
  flex-shrink: 0;
}

.copy-icon-small:hover {
  color: #66b1ff;
}

.danger-text-btn {
  color: #f56c6c;
}

.danger-text-btn:hover {
  color: #f78989;
}

.card-actions {
  display: flex;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid #e4e7ed;
}

.card-actions .el-button {
  flex: 1;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.selection-box {
  position: absolute;
  border: 1px solid #409EFF;
  background-color: rgba(64, 158, 255, 0.1);
  pointer-events: none;
  z-index: 100;
}

/* 缩略图视图样式 */
.thumbnail-view {
  margin-top: 12px;
  position: relative;
  min-height: 200px;
  max-height: 600px; /* 限制高度，超出滚动 */
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #c0c4cc #f5f7fa;
}

.thumbnail-view::-webkit-scrollbar {
  width: 8px;
}

.thumbnail-view::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 4px;
}

.thumbnail-view::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 4px;
}

.thumbnail-view::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

.thumbnail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px;
  padding: 8px;
}

.thumbnail-item {
  position: relative;
  background: #fff;
  border: 2px solid #e4e7ed;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.thumbnail-item:hover {
  border-color: #409EFF;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.25);
  transform: translateY(-3px);
}

.thumbnail-item.selected {
  border-color: #409EFF;
  background-color: #ecf5ff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.thumbnail-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  filter: grayscale(60%);
}

.thumbnail-item.disabled:hover {
  border-color: #e4e7ed;
  transform: none;
  box-shadow: none;
}

.thumbnail-checkbox {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 4px;
  padding: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.thumbnail-missing-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 10;
  background: rgba(230, 162, 60, 0.9);
  color: #fff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

/* 缩略图上新标识 - New + 火苗特效 */
.thumbnail-new-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 3px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
  color: #fff;
  border-radius: 12px;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.4);
  animation: fireGlow 1.5s infinite;
}

.new-text {
  letter-spacing: 0.5px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.fire-icon {
  font-size: 12px;
  animation: fireFlicker 0.8s infinite;
}

@keyframes fireGlow {
  0%, 100% {
    box-shadow: 0 2px 8px rgba(255, 107, 107, 0.4);
  }
  50% {
    box-shadow: 0 2px 12px rgba(255, 107, 107, 0.7);
  }
}

@keyframes fireFlicker {
  0%, 100% {
    transform: scale(1) rotate(0deg);
  }
  25% {
    transform: scale(1.1) rotate(-5deg);
  }
  50% {
    transform: scale(1) rotate(0deg);
  }
  75% {
    transform: scale(1.1) rotate(5deg);
  }
}
.thumbnail-preview {
  position: relative;
  width: 100%;
  aspect-ratio: 9 / 16;
  background: #f5f7fa;
  overflow: hidden;
}

.thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.thumbnail-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.thumbnail-item:hover .thumbnail-image {
  transform: scale(1.05);
}

.no-thumbnail-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #909399;
  font-size: 36px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ed 100%);
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.thumbnail-item:hover .play-overlay {
  opacity: 1;
}

.play-overlay i {
  font-size: 32px;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.thumbnail-info {
  padding: 8px;
  background: #fff;
}

.thumbnail-name {
  font-size: 12px;
  color: #303133;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
}
/* 缩略图性能数据 */
.thumbnail-performance {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 6px;
  padding: 4px 6px;
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.perf-item {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 500;
  flex: 1;
  justify-content: center;
}

.perf-item i {
  font-size: 12px;
}

.cost-item {
  color: #f56c6c;
}

.cost-item i {
  color: #f56c6c;
}

.roas-item {
  color: #67c23a;
}

.roas-item i {
  color: #67c23a;
}
.thumbnail-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
}

.meta-tag {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.duration-text {
  font-size: 11px;
  color: #909399;
  font-weight: 500;
}

.thumbnail-delete-btn {
  position: absolute;
  right: 6px;
  bottom: 6px;
  z-index: 11;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.thumbnail-item:hover .thumbnail-delete-btn {
  opacity: 1;
}

.thumbnail-item.selecting {
  border-color: #409EFF;
  background-color: rgba(64, 158, 255, 0.08);
}

.thumbnail-selection-box {
  position: absolute;
  border: 2px solid #409EFF;
  background-color: rgba(64, 158, 255, 0.15);
  pointer-events: none;
  z-index: 100;
  border-radius: 4px;
}
/* 列表视图样式（文件管理器风格） */
.list-view {
  margin-top: 16px;
  min-height: 200px;
  position: relative;
}

.file-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 4px;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background: #fff;
  border: 1px solid transparent;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.15s ease;
  user-select: none;
}

.file-item:hover {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
}

.file-item.selected {
  background-color: #ecf5ff;
  border-color: #409EFF;
}

.file-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.file-item.disabled:hover {
  background-color: #fff;
  border-color: transparent;
}

.file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-right: 8px;
  color: #409EFF;
  font-size: 18px;
  flex-shrink: 0;
}

.file-info {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.file-name {
  font-size: 13px;
  color: #303133;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  line-height: 1.4;
}

.file-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #909399;
  line-height: 1.3;
}

.file-meta .el-tag {
  flex-shrink: 0;
}

.meta-item {
  white-space: nowrap;
}

.meta-separator {
  color: #dcdfe6;
  margin: 0 2px;
}

.file-checkbox {
  margin-left: 8px;
  flex-shrink: 0;
}

.file-preview-btn,
.file-delete-btn {
  margin-left: 8px;
  flex-shrink: 0;
}

.file-delete-btn {
  color: #f56c6c;
}

.file-delete-btn:hover {
  color: #f78989;
}

.file-checkbox {
  margin-left: 8px;
  flex-shrink: 0;
}

.file-item.selecting {
  border-color: #409EFF;
  background-color: rgba(64, 158, 255, 0.08);
}


.list-selection-box {
  position: absolute;
  border: 2px solid #409EFF;
  background-color: rgba(64, 158, 255, 0.15);
  pointer-events: none;
  z-index: 100;
  border-radius: 4px;
}

@media (max-width: 1600px) {
  .video-cards {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 1200px) {
  .video-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 900px) {
  .video-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .video-cards {
    grid-template-columns: repeat(1, 1fr);
  }
}
/* 性能数据区域样式 */
.performance-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 8px;
  border: 1px solid #e4e7ed;
}

.performance-highlight {
  margin-bottom: 6px;
  padding-bottom: 6px;
  border-bottom: 1px dashed #dcdfe6;
}

.cost-value {
  color: #f56c6c !important;
  font-weight: 600;
  font-size: 13px;
}

.performance-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px;
  margin-bottom: 6px;
}

.performance-dates {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  font-size: 10px;
  color: #909399;
  padding-top: 4px;
  border-top: 1px dashed #dcdfe6;
}

.date-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 11px;
  line-height: 1.4;
}

.info-item .label {
  color: #909399;
  min-width: 60px;
  flex-shrink: 0;
}

.info-item .value {
  color: #606266;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.missing-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 10;
}

.missing-badge .el-tag {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 10px;
  padding: 0 6px;
  height: 20px;
  line-height: 20px;
}

.video-checkbox {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 10;
}

.query-form {
  margin-bottom: 16px;
}

/* 高级筛选条件样式 */
.advanced-filter-item {
  animation: slideIn 0.3s ease;
  background: #f0f9ff;
  border-radius: 4px;
  padding: 4px 8px;
  margin-right: 8px !important;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}/* 性能数据操作区 */
.performance-actions {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #dcdfe6;
  text-align: center;
}

.performance-actions .el-button {
  width: 100%;
}

/* 趋势对话框样式 */
.trend-dialog-content {
  min-height: 200px;
}

.trend-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.trend-header {
  margin-bottom: 8px;
}

.trend-summary {
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e4e7ed;
}

.summary-title {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #303133;
  display: flex;
  align-items: center;
  gap: 6px;
}

.summary-title i {
  color: #409EFF;
}

.summary-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.summary-card {
  background: #fff;
  border-radius: 6px;
  padding: 12px;
  border: 1px solid #e4e7ed;
  text-align: center;
  transition: all 0.3s;
}

.summary-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.card-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
}

.card-value {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.cost-card .card-value {
  color: #f56c6c;
}

.roas-card .card-value {
  color: #67c23a;
}

.impressions-card .card-value {
  color: #409EFF;
}

.clicks-card .card-value {
  color: #e6a23c;
}

.conversions-card .card-value {
  color: #9c27b0;
}

.ctr-card .card-value {
  color: #00bcd4;
}

.trend-table-container {
  margin-top: 8px;
}

.table-title {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #303133;
  display: flex;
  align-items: center;
  gap: 6px;
}

.table-title i {
  color: #409EFF;
}
</style>
